/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_TaxonomyInputs */

const en_directory_submit_enrich_stage_taxonomy = /** @type {(inputs: Directory_Submit_Enrich_Stage_TaxonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read categories`)
};

const zh_directory_submit_enrich_stage_taxonomy = /** @type {(inputs: Directory_Submit_Enrich_Stage_TaxonomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读取分类`)
};

/**
* | output |
* | --- |
* | "Read categories" |
*
* @param {Directory_Submit_Enrich_Stage_TaxonomyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_taxonomy = /** @type {((inputs?: Directory_Submit_Enrich_Stage_TaxonomyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_TaxonomyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_taxonomy(inputs)
	return zh_directory_submit_enrich_stage_taxonomy(inputs)
});
export { directory_submit_enrich_stage_taxonomy as "directory.submit.enrich.stage.taxonomy" }